import * as React from "react";
import { useCallback, useState } from "react";
import { ContextStore } from "../../../../../../../../react-core/Flux/Variables";
import { Lightbox, LightboxType } from "../../../../../../../../react-core/Html/Components/Lightbox";
import { IsaAllowanceOverviewClient } from "../../../../../../../../Wrap/Api/ProductOverview/PaymentsIn/IsaAllowanceOverview";
import { ContextType } from "../../../../../../../../Wrap/Constants/Enums/ContextType";
import { PaymentSource } from "../../../../../../../../Wrap/Constants/Enums/Domain/PaymentSource";
import { SubAccountType } from "../../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { UserClaim } from "../../../../../../../../Wrap/Constants/Enums/UserClaim";
import { InvestorType } from "../../../../../../../../Wrap/Models/Domains/Account/SlAccounts/InvestorType";
import { TrustDetail } from "../../../../../../../../Wrap/Models/Domains/Account/TrustDetail";
import { IsaAllowance } from "../../../../../../../../Wrap/Models/Domains/IsaAllowance/IsaAllowance";
import { ProductValuation } from "../../../../../../../../Wrap/Models/Domains/Valuation/ProductValuation";
import { ProductValuationDetailSummary } from "../../../../../../../../Wrap/Models/Domains/Valuation/ProductValuationDetailSummary";
import { PaymentStatus } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/PaymentStatus";
import { CashPayment } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Payment/CashPayment";
import { CashPaymentFrequencyQuery } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Payment/CashPaymentFrequencyQuery";
import { CashPaymentTypeQuery } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Payment/CashPaymentTypeQuery";
import { InstructionType } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Payment/InstructionType";
import { TextAndDots } from "../../../../../../../Shared/Dropdown/TextAndDots";
import AdviserSiteTagManager, {
    eventCategoryForGTM,
} from "../../../../../../../Shared/Cookies/ChoicesCookie/AdviserSiteTagManager";
import { ProcessType } from "../../../../../../../Shared/IST/Resource/Content";
import { checkPermission } from "../../../../../../../Shared/Permission/PermissionHelper";
import { Action } from "../../../../../../Actions/Action";
import { StaticUrls } from "../../../../../../Resoures/StaticUrls";
import { SubAccountTypeHelper } from "../../../../Common/Helpers/SubAccountTypeHelper";
import { WizardLinkRestriction } from "../../../../Common/Restrictions/WizardLinkRestriction";
import { findHeadAccount } from "../../Common/PortfolioDashboardHelper";
import { PortfolioDashboardStore } from "../../../Store/Variable";
import { SelectRegularPaymentPop } from "../../Common/SelectRegularPaymentPop";
import { JsonDateParser } from "../../../../../../../../react-core/Utils/JsonDateParser";
import { CompanyWizardAction } from "../../../../../../../Admin/Company/CompanyWizard/Actions/CompanyWizardAction";
import { FsaPermission } from "../../../../../../../../Wrap/Models/Models/Company/FsaPermission";
import {
    CompanyFsaPermissionsStore,
} from "../../../../../../../Admin/Company/CompanyWizard/Stores/Variable";
import {useSubscribeToStore} from "../../../../../../../../react-core/Flux/Hooks/useSubscribeToStore";
import { PensionSubAccountSettings } from "../../../../../../../../Wrap/Models/Domains/SubAccount/PensionSubAccountSettings";
import { PensionArrangement } from "../../../../../../../../Wrap/Models/Models/Account/PensionArrangement";
import { PensionArrangementType } from "../../../../../../../../Wrap/Constants/Enums/Domain/PensionArrangementType";
import { ignoreExisitingRegularPaymentForSubAccountSubTypes } from "../../../../RegularPaymentWizard/Resource/Constants";
import { PensionSubAccountSettingsDispatcher, PensionSubAccountSettingsStore, UserStore } from "../../../../../../Stroes/Variable";
import { User } from "../../../../../../../../Wrap/Models/Models/User/User";
import { RestrictionReason } from "../../../../../../../../Wrap/Models/Models/Account/Restrictions/RestrictionReason";
import { DashboardAction } from "../../../../../Dashboard/Action/DashboardAction";
import { ActivityStatus } from "../../../../../../../../Wrap/Constants/Enums/Client/DashboardFilter/ActivityStatus";
import { ProcessType as WorkflowProcessType } from '../../../../../../../../Wrap/Constants/Enums/Client/DashboardFilter/ProcessType';
import { HierarchyIdHelper } from "../../../../../../../Shared/Common/HierarchyIdHelper";
import { ActionType } from "../../../../../../../../react-core/Flux/ActionType";
import { useRestrictionActivitiesHook } from "../../../../Common/Restrictions/useRestrictionActivitiesHook";
import { AllLevelRestrictionStore } from "../../../../Common/Restrictions/Variable";
import { RestrictionAction } from "../../../../Common/Restrictions/RestrictionAction";

interface IThreeDotsDropdownProps {
    isAppStoreEnabled: boolean;
    data: ProductValuation | ProductValuationDetailSummary;
    headAccountHierarchyId: string;
    subAccountHierarchyId: string;
    regularPaymentsIn: boolean;
    isWithDrawalRestriction: boolean;
    trustDetail: TrustDetail;
    buttonTitle?: string;
    restrictionReasons: RestrictionReason[];
    restrictWithdrawal: () => void; // callback for restricted account to withdrawal, (ISA, PP, NPR)
    prohibitedWithdrawal: () => void; // callback for prohibited account (onshore/offshore bond)
}

const pensionRequests = new Set<string>();

export const ThreeDotsDrodpwn = (props: IThreeDotsDropdownProps) => {
    const textLinks = [];
    const item = props.data;
    const {
        isAppStoreEnabled,
        headAccountHierarchyId,
        subAccountHierarchyId,
        regularPaymentsIn,
        isWithDrawalRestriction,
    } = props;
    const [tpbIncompleteActivityExists, setTpbIncompleteActivityExists] = useState<boolean>(false);
    const [takePensionBenefitClicked, setTakePensionBenefitClicked] = useState<boolean>(false);
    const [currentYearIsaAllowance, setCurrentYearIsaAllowance] = useState<IsaAllowance>(null);
    const [lastYearIsaAllowance, setLastYearIsaAllowance] = useState<IsaAllowance>(null);
    const [currentYearIsaAllowanceLoading, setCurrentYearUsaAllowanceLoading] = useState<boolean>(false);
    const [isPensionSubAccountSettingsLoading, setIsPensionSubAccountSettingsLoading] = useState<boolean>(false);
    const [lastYearIsaAllowanceLoading, setLastYearUsaAllowanceLoading] = useState<boolean>(false);
    const [showErrorMsg, setShowErrorMsg] = useState<boolean>(false);
    const [multiPaymentType, setMutiPaymentType] = useState<ProcessType>(null);
    const [companyProductPermission, setCompanyProductPermission] = useState<FsaPermission[]>([]);
    const [selectClientRegular, setSelectClientRegular] = useState<CashPayment[]>([]);
    const [pensionArrangementDetails, setPensionArrangementDetails] = useState<Array<PensionArrangement>>([]);
    const [pensionSubAccountSettings, setPensionSubAccountSettings] = useState<PensionSubAccountSettings>(PensionSubAccountSettingsStore.getPensionSubAccountSettings());
    const hook = useRestrictionActivitiesHook();
    const headAccount = findHeadAccount(
        PortfolioDashboardStore.getData(),
        props.headAccountHierarchyId || props.subAccountHierarchyId
    );
    const nprSubClAccountId = headAccount.SubAccounts?.find(x => x.WrapperType === SubAccountType.Npr)?.ClAccountId;
    const headAccountCompany = headAccount.Company;

    const onCompanyFsaPermissionsChange = useCallback(() => {
        const isLoading = CompanyFsaPermissionsStore.isLoadingForQuery(headAccountCompany);
        const data = CompanyFsaPermissionsStore.getPayload(headAccountCompany);

        if (isLoading || data == null) {
            return;
        }

        setCompanyProductPermission(data);
    }, [headAccountCompany, setCompanyProductPermission]);

    useSubscribeToStore(CompanyFsaPermissionsStore, onCompanyFsaPermissionsChange);
    useSubscribeToStore(PensionSubAccountSettingsStore, () => {
        const data = PensionSubAccountSettingsStore.getPensionSubAccountSettings();
        setPensionSubAccountSettings(data);
        setIsPensionSubAccountSettingsLoading(PensionSubAccountSettingsStore.isLoading());
    });

    React.useEffect(() => {
        if (!AllLevelRestrictionStore.isLoading()) {
            RestrictionAction.getAllLevelRestrictionByHierarchyId(headAccount.HierarchyId);
        }
    }, [headAccount]);

    React.useEffect(() => {
        if (SubAccountTypeHelper.isLegacyProduct(item.ProductType)) {
            const isLoading = CompanyFsaPermissionsStore.isLoadingForQuery(headAccountCompany);
            const data = CompanyFsaPermissionsStore.getPayload(headAccountCompany);

            if (isLoading) {
                return;
            }

            if (data != null) {
                onCompanyFsaPermissionsChange();
                return;
            }

            CompanyWizardAction.getCompanyFsaPermissionDetail(headAccountCompany,"AdviseInvestments");
        }
    }, [headAccountCompany, onCompanyFsaPermissionsChange]);

    React.useEffect(() => {
        if (item.ProductType == SubAccountType.CashIsa) {
            if (!currentYearIsaAllowance && !currentYearIsaAllowanceLoading) {
                setCurrentYearUsaAllowanceLoading(true);
                new IsaAllowanceOverviewClient().get(headAccountHierarchyId, 0).onSuccess((x) => {
                    setCurrentYearIsaAllowance(x);
                    setCurrentYearUsaAllowanceLoading(false);
                });
            }
            if (!lastYearIsaAllowance && !lastYearIsaAllowanceLoading) {
                setLastYearUsaAllowanceLoading(true);
                new IsaAllowanceOverviewClient().get(headAccountHierarchyId, 1).onSuccess((x) => {
                    setLastYearIsaAllowance(x);
                    setLastYearUsaAllowanceLoading(false);
                });
            }
        }
    }, [headAccountHierarchyId]);

    React.useEffect(() => {
        if (
            (item.ProductType === SubAccountType.Npr || item.ProductType === SubAccountType.JuniorSipp) &&
            subAccountHierarchyId
        ) {
            if (pensionRequests.has(subAccountHierarchyId)) {
                return;
            }

            pensionRequests.add(subAccountHierarchyId);

            Action.getPensionArrangementDetails(subAccountHierarchyId, false, (x) => {
                setPensionArrangementDetails(x);
            });

            PensionSubAccountSettingsDispatcher.dispatch({ actionType: ActionType.Loading });
            Action.getPensionSubAccountSettings(subAccountHierarchyId, true, (x) => {
                PensionSubAccountSettingsDispatcher.dispatch({ actionType: ActionType.Success, payload: x });
            });

            DashboardAction.getWorkflowTable({
                activity: WorkflowProcessType.TakePensionBenefit,
                status: ActivityStatus.Pending,
                product: [item.ProductType],
                endDate: JsonDateParser.toJsonDateNoOffset(new Date()),
                beginDate: JsonDateParser.toJsonDateNoOffset(new Date(new Date().setFullYear(new Date().getFullYear() - 1))),
                start: 1,
                count: 1,
                customerId: HierarchyIdHelper.generateHierarchyId(ContextStore.getUrlParamsHierarchyId(ContextType.Customer)).entityId,
                headAccountHierarchyIds: [headAccountHierarchyId],
                subAccountHierarchyIds: [subAccountHierarchyId],
            }, (result) => {
                setTpbIncompleteActivityExists(false);
            });
        }

    }, [subAccountHierarchyId, item.ProductType, headAccountHierarchyId]);


    const handleLaunchpadClick = React.useCallback(() => {
        const context: Record<string, string> = {};

        const customerHierarchyId = ContextStore.getUrlParamsHierarchyId(ContextType.Customer);
        if (customerHierarchyId) {
            context.customerId = customerHierarchyId;
        }
        if (headAccountHierarchyId) {
            context.accountGroupId = headAccountHierarchyId;
        }
        if (subAccountHierarchyId) {
            context.accountId = subAccountHierarchyId;
        }

        (window as any).AppStore.open(context);
    }, [headAccountHierarchyId, subAccountHierarchyId]);

    const { addEvent } = new AdviserSiteTagManager();

    const checkShowPopMsg = (processType: ProcessType): boolean => {        
            return WizardLinkRestriction(headAccount, props.subAccountHierarchyId, processType);
    };

    const isDpcNprAccount = (): boolean => {
        return pensionSubAccountSettings?.HasDisqualifyingPensionCredit ?? false;
    }

    const editRegularLink = (cashEntryId: number) => {
        return StaticUrls.RegularPaymentUrl(
            item.ProductType?.toString(),
            item.ClAccountId,
            headAccountHierarchyId,
            subAccountHierarchyId,
            "edit",
            cashEntryId
        );
    };

    const editWhatIfToolLink = (cashEntryId: number) => {
        return StaticUrls.WhatIfToolUrl(
            item.ProductType?.toString(),
            item.ClAccountId,
            headAccountHierarchyId,
            subAccountHierarchyId,
            cashEntryId,
            false
        );
    };

    const flexiArrangments = pensionArrangementDetails.filter(x => x.Type == PensionArrangementType.Fad);
    const cappedArrangments = pensionArrangementDetails.filter(x => x.Type == PensionArrangementType.Capped);

    const isTrust = headAccount?.InvestorType == InvestorType.Trust;
    let blockTrustTopupAndWithdrawal = false;
    if (isTrust) {
        blockTrustTopupAndWithdrawal = ["loanplan", "discountedgiftplan"].includes(
            (props.trustDetail?.TrustType || "").toLowerCase()
        );
    }
    const disableAllProductByFsa = !companyProductPermission.some(
        (ele) =>
            ele?.FsaRegulatedActivity?.Name?.toLowerCase() == "AdviseInvestments".toLowerCase() &&
            ele.IsInclude &&
            ele.IsPermit
    );

    const addGTMEvent = (actionType: string) => {
        addEvent({
            eventParameters: {
                eventCategory: eventCategoryForGTM.summaryTab,
                eventAction: props.buttonTitle == "Quick actions menu" ? "summary table" : "product details",
                eventLabel: `${item.ProductDisplayName}|${actionType}`,
            },
            event: "summarytab_interaction",
        });
    };
    const clickFunc = (show: boolean, actionType: string, onClick?: VoidFunction): VoidFunction => {
        return show
            ? () => setShowErrorMsg(true)
            : onClick
            ? () => {
                  addGTMEvent(actionType);
                  onClick();
              }
            : () => {
                  addGTMEvent(actionType);
              };
    };

    if (item.ProductType == SubAccountType.CashIsa) {
        if (
            (currentYearIsaAllowance?.Expected.Amount > 0 ||
                currentYearIsaAllowance?.Used.Amount > 0 ||
                lastYearIsaAllowance?.Expected.Amount > 0 ||
                lastYearIsaAllowance?.Used.Amount > 0) &&
            JsonDateParser.toDate(currentYearIsaAllowance?.StopIsaCashDate) >= new Date() &&
            checkPermission(UserClaim.AdviserPortalSPTAndRegularPaymentReadWrite)
        ) {
            const showErrorMsgSPT = checkShowPopMsg(ProcessType.SinglePayment);
            textLinks.push({
                title: StaticUrls.SinglePayment,
                url: showErrorMsgSPT
                    ? "javascript:void(0);"
                    : StaticUrls.SinglePaymentUrl(
                          item.ProductType?.toString(),
                          item.ClAccountId,
                          headAccountHierarchyId,
                          subAccountHierarchyId
                      ),
                clickFunction: clickFunc(showErrorMsgSPT, StaticUrls.SinglePayment),
            });
            if (regularPaymentsIn) {
                const showErrorMsgEditRegular = checkShowPopMsg(ProcessType.EditRegular);
                textLinks.push({
                    title: StaticUrls.RegularPaymentEdit,
                    url: "javascript:void(0);",
                    clickFunction: clickFunc(showErrorMsgEditRegular, StaticUrls.RegularPaymentEdit, () => {
                        Action.getRegularPaymentCashEntry(
                            item.SubAccountHierarchyId,
                            CashPaymentTypeQuery.Deposit,
                            CashPaymentFrequencyQuery.Regular,
                            (result: CashPayment[]) => {
                                const clientRegularPayment = result.filter(
                                    (cashEntry) =>
                                        (cashEntry.Source == PaymentSource.Employee ||
                                            cashEntry.Source == PaymentSource.NotSpecified) &&
                                        cashEntry.InstructionType == InstructionType.Standing &&
                                        cashEntry.Status == PaymentStatus.Authorised
                                );
                                if (clientRegularPayment.length > 1) {
                                    setSelectClientRegular(clientRegularPayment);
                                } else {
                                    window.location.assign(editRegularLink(clientRegularPayment[0]?.BatchId));
                                }
                            }
                        );
                    }),
                });
            } else {
                const showErrorMsgAddRegular = checkShowPopMsg(ProcessType.AddRegular);
                textLinks.push({
                    title: StaticUrls.RegularPayment,
                    url: showErrorMsgAddRegular
                        ? "javascript:void(0);"
                        : StaticUrls.RegularPaymentUrl(
                              item.ProductType?.toString(),
                              item.ClAccountId,
                              headAccountHierarchyId,
                              subAccountHierarchyId,
                              "add"
                          ),
                    clickFunction: clickFunc(showErrorMsgAddRegular, StaticUrls.RegularPayment),
                });
            }
        }
    }
    // top up wizard
    if (
        [
            SubAccountType.InvestmentAccount,
            SubAccountType.StocksIsa,
            SubAccountType.WrapCash,
            SubAccountType.Npr,
            SubAccountType.JuniorSipp
        ].includes(item.ProductType)
    ) {
        const showErrorMsgSPT = checkShowPopMsg(ProcessType.SinglePayment) || isDpcNprAccount();
        if (isTrust) {
            if (checkPermission(UserClaim.AdviserPortalDluNbecCanView)) {
                textLinks.push({
                    title: StaticUrls.SinglePayment,
                    url:
                        showErrorMsgSPT || blockTrustTopupAndWithdrawal
                            ? "javascript:void(0);"
                            : StaticUrls.NBEC(item.ClAccountId, SubAccountTypeHelper.isLegacyProduct(item.ProductType)),
                    clickFunction: clickFunc(showErrorMsgSPT || blockTrustTopupAndWithdrawal, StaticUrls.SinglePayment),
                });
                textLinks.push({
                    title: regularPaymentsIn ? StaticUrls.RegularPaymentEdit : StaticUrls.RegularPayment,
                    url:
                        showErrorMsgSPT || blockTrustTopupAndWithdrawal
                            ? "javascript:void(0);"
                            : StaticUrls.NBEC(item.ClAccountId, SubAccountTypeHelper.isLegacyProduct(item.ProductType)),
                    clickFunction: clickFunc(
                        showErrorMsgSPT || blockTrustTopupAndWithdrawal,
                        regularPaymentsIn ? StaticUrls.RegularPaymentEdit : StaticUrls.RegularPayment
                    ),
                });
            }
        } else {
            if (checkPermission(UserClaim.AdviserPortalSPTAndRegularPaymentReadWrite)) {
                textLinks.push({
                    title: StaticUrls.SinglePayment,
                    url: showErrorMsgSPT
                        ? "javascript:void(0);"
                        : StaticUrls.SinglePaymentUrl(
                              item.ProductType?.toString(),
                              item.ClAccountId,
                              headAccountHierarchyId,
                              subAccountHierarchyId
                          ),
                    clickFunction: clickFunc(showErrorMsgSPT, StaticUrls.SinglePayment),
                });

                if (regularPaymentsIn) {
                    const showErrorMsgEditRegular = checkShowPopMsg(ProcessType.EditRegular) || isDpcNprAccount();
                    textLinks.push({
                        title: StaticUrls.RegularPaymentEdit,
                        url: "javascript:void(0);",
                        clickFunction: clickFunc(showErrorMsgEditRegular, StaticUrls.RegularPaymentEdit, () => {
                            Action.getRegularPaymentCashEntry(
                                item.SubAccountHierarchyId,
                                CashPaymentTypeQuery.Deposit,
                                CashPaymentFrequencyQuery.Regular,
                                (result: CashPayment[]) => {
                                    const clientRegularPayment = result.filter(
                                        (cashEntry) =>
                                            cashEntry.InstructionType == InstructionType.Standing &&
                                            cashEntry.Status == PaymentStatus.Authorised
                                    );
                                    if (clientRegularPayment.length > 1) {
                                        setSelectClientRegular(clientRegularPayment);
                                        setMutiPaymentType(ProcessType.EditRegular);
                                    } else {
                                        window.location.assign(editRegularLink(clientRegularPayment[0]?.BatchId));
                                    }
                                }
                            );
                        }),
                    });
                }

                if(!regularPaymentsIn || ignoreExisitingRegularPaymentForSubAccountSubTypes.includes(item?.ProductType)){
                    const showErrorMsgAddRegular = checkShowPopMsg(ProcessType.AddRegular) || isDpcNprAccount();
                    textLinks.push({
                        title: StaticUrls.RegularPayment,
                        url: showErrorMsgAddRegular
                            ? "javascript:void(0);"
                            : StaticUrls.RegularPaymentUrl(
                                  item.ProductType?.toString(),
                                  item.ClAccountId,
                                  headAccountHierarchyId,
                                  subAccountHierarchyId,
                                  "add"
                              ),
                        clickFunction: clickFunc(showErrorMsgAddRegular, StaticUrls.RegularPayment),
                    });
                }
            }
        }
    }
    const suspendedProcessTypes = hook.returnSuspendedActivities(headAccount.HeadClAccountId, nprSubClAccountId);
    
    // buy sell switch
    if (
        [SubAccountType.InvestmentAccount, SubAccountType.StocksIsa, SubAccountType.Npr, SubAccountType.JuniorSipp].includes(item.ProductType) &&
        checkPermission(UserClaim.AdviserPortalBuySellSwitchReadWrite)
    ) {
        const showErrorMsgBuy = checkShowPopMsg(ProcessType.Buy);
        const showErrorMsgSell = checkShowPopMsg(ProcessType.Sell);
        const showErrorMsgSwitch = checkShowPopMsg(ProcessType.Switch);
        const showErrorMsgTakePensionBenefits = (checkShowPopMsg(ProcessType.TakePensionBenefits) || suspendedProcessTypes.includes(ProcessType.TakePensionBenefits) || tpbIncompleteActivityExists || isDpcNprAccount());
        const showErrorMsgTopUpWithITFLS = (checkShowPopMsg(ProcessType.TopUpWithITFLS) || suspendedProcessTypes.includes(ProcessType.TopUpWithITFLS)) || isDpcNprAccount();
        const showErrorMsgEditIncomeDrawdown = suspendedProcessTypes.includes(ProcessType.EditIncomeDrawdown) || isDpcNprAccount();
        const showErrorMsgEditIncomePayments = suspendedProcessTypes.includes(ProcessType.EditIncome) || isDpcNprAccount();
        const showErrorMsgCancelRegularCrystallisation = suspendedProcessTypes.includes(ProcessType.CancelRegularCrystallisation);
        const showErrorMsgOneoffIncomePayments = suspendedProcessTypes.includes(ProcessType.OneoffIncomePayments) || isDpcNprAccount();
        const showErrorMsgConvertCappedToFlexi = suspendedProcessTypes.includes(ProcessType.ConvertCappedToFlexi);
        const showErrorMsgGadReview = suspendedProcessTypes.includes(ProcessType.GadReview);
        if (isTrust) {
            textLinks.push({
                title: StaticUrls.Buy,
                url: showErrorMsgBuy ? "javascript:void(0);" : StaticUrls.CreateOrder(item.ClAccountId),
                clickFunction: clickFunc(showErrorMsgBuy, StaticUrls.Buy),
            });
            textLinks.push({
                title: StaticUrls.Sell,
                url: showErrorMsgSell ? "javascript:void(0);" : StaticUrls.CreateOrder(item.ClAccountId),
                clickFunction: clickFunc(showErrorMsgSell, StaticUrls.Sell),
            });
            textLinks.push({
                title: StaticUrls.Switch,
                url: showErrorMsgSwitch ? "javascript:void(0);" : StaticUrls.CreateOrder(item.ClAccountId),
                clickFunction: clickFunc(showErrorMsgSwitch, StaticUrls.Switch),
            });
        } else {
            textLinks.push({
                title: StaticUrls.Buy,
                url: showErrorMsgBuy
                    ? "javascript:void(0);"
                    : StaticUrls.BuyUrl(
                        item.ProductType?.toString(),
                        item.ClAccountId,
                        headAccountHierarchyId,
                        subAccountHierarchyId
                    ),
                clickFunction: clickFunc(showErrorMsgBuy, StaticUrls.Buy),
            });

            textLinks.push({
                title: StaticUrls.Sell,
                url: showErrorMsgSell
                    ? "javascript:void(0);"
                    : StaticUrls.SellUrl(
                        item.ProductType?.toString(),
                        item.ClAccountId,
                        headAccountHierarchyId,
                        subAccountHierarchyId
                    ),
                clickFunction: clickFunc(showErrorMsgSell, StaticUrls.Sell),
            });

            textLinks.push({
                title: StaticUrls.Switch,
                url: showErrorMsgSwitch
                    ? "javascript:void(0);"
                    : StaticUrls.SwitchUrl(
                        item.ProductType?.toString(),
                        item.ClAccountId,
                        headAccountHierarchyId,
                        subAccountHierarchyId
                    ),
                clickFunction: clickFunc(showErrorMsgSwitch, StaticUrls.Switch),
            });
        }
        if (pensionSubAccountSettings && (item.ProductType == SubAccountType.Npr || item.ProductType == SubAccountType.JuniorSipp)) {
            if (
                checkPermission(UserClaim.AdviserPortalTPBAndEditIncomeDrawdownReadWrite) &&
                item.ProductType !== SubAccountType.JuniorSipp
            ) {
                textLinks.push({
                    title: StaticUrls.PensionBenefits,
                    url: showErrorMsgTakePensionBenefits
                        ? "javascript:void(0);"
                        : StaticUrls.PensionBenefitsUrl(
                        item.ProductType.toString(),
                        item.ClAccountId,
                        headAccountHierarchyId,
                        subAccountHierarchyId,
                        false
                    ),
                    clickFunction: clickFunc(showErrorMsgTakePensionBenefits, StaticUrls.PensionBenefits),
                });
            }
            if (checkPermission(UserClaim.AdviserPortalITFCReadWrite) && item.ProductType !== SubAccountType.JuniorSipp) {
                textLinks.push({
                    title: StaticUrls.Topup,
                    url: showErrorMsgTopUpWithITFLS
                        ? "javascript:void(0);"
                        : StaticUrls.TopupUrl(
                        item.ProductType.toString(),
                        item.ClAccountId,
                        headAccountHierarchyId,
                        subAccountHierarchyId,
                        false
                    ),
                    clickFunction: clickFunc(showErrorMsgTopUpWithITFLS, StaticUrls.Topup),
                });
            }
            if (pensionSubAccountSettings.CanEditIncome  && pensionSubAccountSettings.CanEditRegularCrystallisation && checkPermission(UserClaim.AdviserPortalTPBAndEditIncomeDrawdownReadWrite)) {
                textLinks.push({
                    title: StaticUrls.EditIncomeDrawdown,
                    url: showErrorMsgEditIncomeDrawdown 
                    ? "javascript:void(0);"
                    : StaticUrls.EditIncomeDrawdownUrl(
                        item.ProductType.toString(),
                        item.ClAccountId,
                        headAccountHierarchyId,
                        subAccountHierarchyId,
                        false
                    ),
                    clickFunction: clickFunc(showErrorMsgEditIncomeDrawdown, StaticUrls.EditIncomeDrawdown),
                });
            }
            if (pensionSubAccountSettings.CanEditIncome && (cappedArrangments?.length > 0 || flexiArrangments?.length > 0) && checkPermission(UserClaim.AdviserPortalEditIncomePaymentsReadWrite)) {
                textLinks.push({
                    title: StaticUrls.EditIncomeWithdrawals,
                    url: showErrorMsgEditIncomePayments
                        ? "javascript:void(0);"
                        : StaticUrls.EditIncomeWithdrawalsUrl(
                        item.ProductType.toString(),
                        item.ClAccountId,
                        headAccountHierarchyId,
                        subAccountHierarchyId,
                        false
                    ),
                    clickFunction: clickFunc(showErrorMsgEditIncomePayments, StaticUrls.EditIncomeWithdrawals),
                });
            }
            if (pensionSubAccountSettings.CanEditRegularCrystallisation && checkPermission(UserClaim.AdviserPortalCancelRegularCrystalisationReadWrite)) {
                textLinks.push({
                    title: StaticUrls.CancelRegularCrystallisation,
                    url: showErrorMsgCancelRegularCrystallisation
                     ? "javascript:void(0);"
                     : StaticUrls.CancelRegularCrystallisationUrl(
                        item.ProductType.toString(),
                        item.ClAccountId,
                        headAccountHierarchyId,
                        subAccountHierarchyId,
                    ),
                    clickFunction: clickFunc(showErrorMsgCancelRegularCrystallisation, StaticUrls.CancelRegularCrystallisation),
                });
            }
            if (pensionSubAccountSettings.GadReviewEnabled && pensionSubAccountSettings.GadReviewEnabledArrangementIds?.length > 0 && checkPermission(UserClaim.AdviserPortalGADReviewReadWrite)) {
                pensionSubAccountSettings.GadReviewEnabledArrangementIds.forEach((arrangementId) => {
                    textLinks.push({
                        title: `${StaticUrls.EditGadReview} (${arrangementId})`,
                        url: showErrorMsgGadReview
                        ? "javascript:void(0);"
                        :StaticUrls.EditGadReviewUrl(
                            item.ProductType.toString(),
                            item.ClAccountId,
                            headAccountHierarchyId,
                            subAccountHierarchyId, 
                            false,
                            arrangementId
                        ),
                        clickFunction: clickFunc(showErrorMsgGadReview, StaticUrls.EditGadReview),
                    });
                });
            }
            if (pensionSubAccountSettings.CanConvertToFlexi && checkPermission(UserClaim.AdviserPortalConvertCappedToFlexiReadWrite)) {
                textLinks.push({
                    title: StaticUrls.ConvertCappedToFlexi,
                    url: showErrorMsgConvertCappedToFlexi
                    ? "javascript:void(0);"
                    : StaticUrls.ConvertCappedToFlexiUrl(
                        item.ProductType.toString(),
                        item.ClAccountId,
                        headAccountHierarchyId,
                        subAccountHierarchyId
                    ),
                    clickFunction: clickFunc(showErrorMsgConvertCappedToFlexi, StaticUrls.ConvertCappedToFlexi),
                });
            }
            if (pensionSubAccountSettings.CanEditIncome && (cappedArrangments?.length > 0 || flexiArrangments?.length > 0) && checkPermission(UserClaim.AdviserPortalOneoffIncomePaymentReadWrite)) {
                textLinks.push({
                    title: StaticUrls.IncomePaymentOneOff,
                    url: showErrorMsgOneoffIncomePayments
                    ? "javascript:void(0);"
                    :StaticUrls.IncomePaymentOneOffUrl(
                        item.ProductType.toString(),
                        item.ClAccountId,
                        headAccountHierarchyId,
                        subAccountHierarchyId
                    ),
                    clickFunction: clickFunc(showErrorMsgOneoffIncomePayments, StaticUrls.IncomePaymentOneOff),
                });
            }
        }
    }
    const showErrorMsgWithdrawal = checkShowPopMsg(ProcessType.Withdrawal);
    if (
        [
            SubAccountType.InvestmentAccount,
            SubAccountType.StocksIsa,
            SubAccountType.WrapCash,
            SubAccountType.CashIsa,
        ].includes(item.ProductType) &&
        checkPermission(UserClaim.AdviserPortalDluWithdrawalCanView)
    ) {
        textLinks.push({
            title: StaticUrls.Withdraw,
            url: "javascript:void(0);",
            clickFunction: () => {
                if (showErrorMsgWithdrawal || blockTrustTopupAndWithdrawal) {
                    setShowErrorMsg(true);
                } else if (isWithDrawalRestriction) {
                    props.restrictWithdrawal();
                } else {
                    addGTMEvent(StaticUrls.Withdraw);
                    window.location.assign(StaticUrls.WithdrawUrl(item.ClAccountId));
                }
            },
        });
    }
    if ([SubAccountType.InvestmentAccount, SubAccountType.StocksIsa, SubAccountType.Npr, SubAccountType.JuniorSipp].includes(item.ProductType)) {
        const showErrorMsgWhatIf = checkShowPopMsg(ProcessType.WhatIf) || isDpcNprAccount();
        const showErrorMsgNoChange = checkShowPopMsg(ProcessType.NoChange);
        if (checkPermission(UserClaim.AdviserPortalSPTAndRegularPaymentReadWrite)) {
            if (!isTrust && item.ProductType !== SubAccountType.JuniorSipp) {
                textLinks.push({
                    title: StaticUrls.WhatIfTool,
                    url: "javascript:void(0);",
                    clickFunction: clickFunc(showErrorMsgWhatIf, StaticUrls.WhatIfTool, () => {
                        Action.getRegularPaymentCashEntry(
                            item.SubAccountHierarchyId,
                            CashPaymentTypeQuery.Deposit,
                            CashPaymentFrequencyQuery.Regular,
                            (result: CashPayment[]) => {
                                const clientRegularPayment = result.filter(
                                    (cashEntry) =>
                                        (cashEntry.Source == PaymentSource.Employee ||
                                            cashEntry.Source == PaymentSource.NotSpecified) &&
                                        cashEntry.InstructionType == InstructionType.Standing &&
                                        cashEntry.Status == PaymentStatus.Authorised
                                );
                                if (clientRegularPayment.length > 1) {
                                    setSelectClientRegular(clientRegularPayment);
                                    setMutiPaymentType(ProcessType.WhatIf);
                                } else {
                                    window.location.assign(editWhatIfToolLink(clientRegularPayment[0]?.BatchId));
                                }
                            }
                        );
                    }),
                });
            }
            textLinks.push({
                title: StaticUrls.NoChangeTool,
                url: showErrorMsgNoChange
                    ? "javascript:void(0);"
                    : StaticUrls.NoChangeToolUrl(
                          item.ProductType.toString(),
                          item.ClAccountId,
                          headAccountHierarchyId,
                          subAccountHierarchyId
                      ),
                clickFunction: clickFunc(showErrorMsgNoChange, StaticUrls.NoChangeTool),
            });
        }
    }
    if (item.ProductType == SubAccountType.InvestmentAccount) {
        if (checkPermission(UserClaim.AdviserPortalPPToSIPPAndISAReadWrite)) {
            const customerHierarchyId = ContextStore.getUrlParamsHierarchyId(ContextType.Customer);

            textLinks.push({
                title: StaticUrls.PPToSsIsa,
                url: StaticUrls.ppToSsIsaUrl(
                    item.ClAccountId,
                    headAccountHierarchyId,
                    subAccountHierarchyId,
                    customerHierarchyId
                ),
                clickFunction: clickFunc(false, StaticUrls.PPToSsIsa),
            });
        }
    }

    if (item.ProductType == SubAccountType.InvestmentAccount) {
        if (checkPermission(UserClaim.AdviserPortalPPToSIPPAndISAReadWrite)) {
            const customerHierarchyId = ContextStore.getUrlParamsHierarchyId(ContextType.Customer);

            textLinks.push({
                title: StaticUrls.ppToAbrdnSIPP,
                url: StaticUrls.ppToAbrdnSIPPUrl(
                    item.ClAccountId,
                    headAccountHierarchyId,
                    subAccountHierarchyId,
                    customerHierarchyId
                ),
                clickFunction: clickFunc(false, StaticUrls.PPToSsIsa),
            });
        }
    }

    if ([SubAccountType.Sipp, SubAccountType.OnshoreBond, SubAccountType.OffshoreBond].includes(item.ProductType)) {
        const showErrorMsgSPT = checkShowPopMsg(ProcessType.SinglePayment);
        if (checkPermission(UserClaim.AdviserPortalDluNbecCanView)) {
            textLinks.push({
                title: StaticUrls.SinglePayment,
                url:
                    showErrorMsgSPT || blockTrustTopupAndWithdrawal || disableAllProductByFsa
                        ? "javascript:void(0);"
                        : StaticUrls.NBEC(item.ClAccountId, SubAccountTypeHelper.isBond(item.ProductType)),
                clickFunction: clickFunc(
                    showErrorMsgSPT || blockTrustTopupAndWithdrawal || disableAllProductByFsa,
                    StaticUrls.SinglePayment
                ),
            });
        }
    }
    if (item.ProductType == SubAccountType.Sipp) {
        const showErrorMsgRegular = checkShowPopMsg(ProcessType.AddRegular);
        if (checkPermission(UserClaim.AdviserPortalDluNbecCanView)) {
            textLinks.push({
                title: regularPaymentsIn ? StaticUrls.RegularPaymentEdit : StaticUrls.RegularPayment,
                url:
                    showErrorMsgRegular || blockTrustTopupAndWithdrawal || disableAllProductByFsa
                        ? "javascript:void(0);"
                        : StaticUrls.NBEC(item.ClAccountId),
                clickFunction: clickFunc(
                    showErrorMsgRegular || blockTrustTopupAndWithdrawal || disableAllProductByFsa,
                    regularPaymentsIn ? StaticUrls.RegularPaymentEdit : StaticUrls.RegularPayment
                ),
            });
        }
    }
    if (
        [SubAccountType.Sipp, SubAccountType.OffshoreBond].includes(item.ProductType) &&
        checkPermission(UserClaim.AdviserPortalBuySellSwitchReadWrite)
    ) {
        const showErrorMsgBuy = checkShowPopMsg(ProcessType.Buy);
        const showErrorMsgSell = checkShowPopMsg(ProcessType.Sell);

        textLinks.push({
            title: StaticUrls.Buy,
            url: showErrorMsgBuy ? "javascript:void(0);" : StaticUrls.CreateOrder(item.ClAccountId),
            clickFunction: clickFunc(showErrorMsgBuy, StaticUrls.Buy),
        });
        textLinks.push({
            title: StaticUrls.Sell,
            url: showErrorMsgSell ? "javascript:void(0);" : StaticUrls.CreateOrder(item.ClAccountId),
            clickFunction: clickFunc(showErrorMsgSell, StaticUrls.Sell),
        });
    }
    if (
        [SubAccountType.Sipp, SubAccountType.OnshoreBond, SubAccountType.OffshoreBond].includes(item.ProductType) &&
        checkPermission(UserClaim.AdviserPortalBuySellSwitchReadWrite)
    ) {
        const showErrorMsgSwitch = checkShowPopMsg(ProcessType.Switch);
        textLinks.push({
            title: StaticUrls.Switch,
            url: showErrorMsgSwitch ? "javascript:void(0);" : StaticUrls.CreateOrder(item.ClAccountId),
            clickFunction: clickFunc(showErrorMsgSwitch, StaticUrls.Switch),
        });
    }
    if (
        [SubAccountType.OnshoreBond, SubAccountType.OffshoreBond].includes(item.ProductType) &&
        checkPermission(UserClaim.AdviserPortalDluWithdrawalCanView)
    ) {
        const showErrorMsgWithdrawal = checkShowPopMsg(ProcessType.Withdrawal);
        textLinks.push({
            title: StaticUrls.Withdraw,
            url: "javascript:void(0);",
            clickFunction: () => {
                if (showErrorMsgWithdrawal || blockTrustTopupAndWithdrawal) {
                    setShowErrorMsg(true);
                } else {
                    addGTMEvent(StaticUrls.Withdraw);
                    props.prohibitedWithdrawal();
                }
            },
        });
    }
    if (isAppStoreEnabled) {
        textLinks.push({ title: StaticUrls.LaunchApps, clickFunction: handleLaunchpadClick });
    }
    if (textLinks.filter((ele) => ele != null).length == 0) {
        return null;
    }

    const onMenuClick = (processName: string) => {
        if(processName == StaticUrls.PensionBenefits){
            setTakePensionBenefitClicked(true);
        }
    }

    return (
        <>
            {textLinks?.length > 0 && <TextAndDots textLinks={textLinks} buttonTitle={props.buttonTitle} onMenuClick={onMenuClick} isLoading={isPensionSubAccountSettingsLoading}/>}
            {showErrorMsg && (
                <Lightbox
                    show={showErrorMsg}
                    title={"Warning"}
                    contentAfterTitle={null}
                    onClose={() => {
                        setShowErrorMsg(false);
                        setTakePensionBenefitClicked(false);
                    }}
                    type={LightboxType.Modal}
                    cssWrapper={"is-default-lightbox"}
                >
                    <p>
                        {(() => {
                            if (blockTrustTopupAndWithdrawal) {
                                return "This journey is not available for this type of Trust.";
                            }
                            if (disableAllProductByFsa && SubAccountTypeHelper.isLegacyProduct(item.ProductType)) {
                                return "FCA Permissions prevents the following action.";
                            }
                            if(isDpcNprAccount()){
                                return "This plan includes disqualifying pension credit. Unfortunately, instructions cannot be completed online. Please contact us on 0345 279 1001.";
                            }
                            if (hook.isBlockedByPensionProcessingRestriction(headAccount.HeadClAccountId, nprSubClAccountId)) {
                                return "You cannot process this action until pension event is authorised";
                            }
                            if (hook.isPensionActivitiesBeenSuspended(headAccount.HeadClAccountId, nprSubClAccountId)){
                                return "An account with suspended or restricted activities cannot start this journey";
                            }
                            if (tpbIncompleteActivityExists && takePensionBenefitClicked) {
                                return "You cannot process this action due to another In Progress journey.";
                            }
                            return "You cannot process this action until the account is active";
                        })()}
                    </p>
                    <button className="btn primary" onClick={() => setShowErrorMsg(false)}>
                        Ok
                    </button>
                </Lightbox>
            )}
            {checkPermission(UserClaim.AdviserPortalSPTAndRegularPaymentReadWrite) && (
                <SelectRegularPaymentPop
                    clientRegularPayment={selectClientRegular}
                    onClose={() => {
                        setSelectClientRegular([]);
                    }}
                    onSelect={(id) =>
                        window.location.assign(
                            multiPaymentType == ProcessType.EditRegular ? editRegularLink(id) : editWhatIfToolLink(id)
                        )
                    }
                />
            )}
        </>
    );
};
